import AuthProvider from "@auth/context/Auth.provider";
import { ToastContextProvider } from "@celebration/react";
import ClientProvider from "@contexts/Client.provider";
import ConfigurationProvider from "@contexts/Configuration.provider";
import { BrowserRouter } from "react-router-dom";
import { CustomProvider } from "rsuite";
import ptBR from "rsuite/locales/pt_BR";

import "@shared/i18n/i18n";

const AppProviders: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ConfigurationProvider>
    <ToastContextProvider>
      <BrowserRouter>
        <AuthProvider>
          <ClientProvider>
            <CustomProvider locale={ptBR}>{children}</CustomProvider>
          </ClientProvider>
        </AuthProvider>
      </BrowserRouter>
    </ToastContextProvider>
  </ConfigurationProvider>
);

export default AppProviders;
